<script setup>
import { useRouter } from "vue-router";
import Button from "primevue/button";
import ScrollPanel from "primevue/scrollpanel";
import CriarQuestoesOpcoes from "@/components/professor/CriarQuestoes/Opcoes.vue";
import VisualizarCardQuestao from "@/components/professor/CriarQuestoes/VisualizarCardQuestao.vue";

import { storeToRefs } from "pinia";
import { useCriarQuestoesStore } from "@/store/criarQuestoes";
import ListaQuestoes from "@/components/professor/CriarQuestoes/ListaQuestoes.vue";
import HeaderDetailsPage from "@/components/layout/HeaderDetailsPage.vue";
import { computed } from "vue";
const router = useRouter();

function goBack() {
    router.push('/professor')
}
const store = useCriarQuestoesStore();
const { carregandoDados} = storeToRefs(store);
const alturaTela = computed(() => {
    return window.innerHeight - 2 + 'px';
})

</script>
<template>
    <HeaderDetailsPage titulo="Criar Questões" :loading="carregandoDados" />
    <div class="flex flex-column md:flex-row border-round">
        <div class="w-12 md:w-5  pb-4 bg-white border-bottom-1  md:border-bottom-none md:border-right-1 surface-border md:h-screen md:sticky"
            style="top: 60px">
            <ScrollPanel :style="{ width: '100%', height: alturaTela }">
                <CriarQuestoesOpcoes class="px-4" />
            </ScrollPanel>


        </div>
        
        <div class="w-12 md:w-7 p-4 lg:p-6 md:pt-8 lg:pt-8 flex flex-grow-1 flex-column surface-50">
            <VisualizarCardQuestao />
        </div>
    </div>
</template>